import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { ILocation } from '../../models/location';
import { GoogleMapService } from '../../services/google-map.service';

export class GoogleMapComponent {
    public static $inject = [
        'googleMapService',
        '$timeout',
        '$uibModal',
        '$document'
    ];

    public mapOptions;
    public view;
    public edit;
    public infoWindow;
    public marker;
    public isMapReady: boolean;
    public location: ILocation;
    public readonly: boolean = false;
    public title: string;
    public search: string = '';
    public contentTranslateKey: string;
    public searchFieldVisible: boolean = true;

    public onUpdateLocation: () => void;
    public positionByAddress: (value: any) => void;
    public onLocationChanged: (value: any) => void;

    private mapsApi;
    private defaultLatLng = { lat: 51.500152, lng: -0.126236 };
    private loaded = false;
    private markerListenerInitialized = false;

    constructor(
        private googleMapService: GoogleMapService,
        private $timeout: ng.ITimeoutService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $document: ng.IDocumentService
    ) {
    }

    public async $onInit() {
        this.mapsApi = await this.googleMapService.getGoogleMaps();
        let position;
        if (this.location && this.location.Latitude && this.location.Longitude) {
            position = new this.mapsApi.LatLng(this.location.Latitude, this.location.Longitude);
        } else {
            position = new this.mapsApi.LatLng(this.defaultLatLng.lat, this.defaultLatLng.lng);
            this.onLocationChanged({value: this.defaultLatLng });
        }
        this.mapOptions = {
            center: position,
            zoom: 16,
            mapTypeId: this.mapsApi.MapTypeId.ROADMAP,
            zoomControl: true,
            scrollwheel: true,
            disableDefaultUI: true,
            disableDoubleClickZoom: false,
            scaleControl: true,
            draggableCursor: 'default',
            draggingCursor: this.readonly ? 'move' : 'default'
        };
        this.infoWindow = new this.mapsApi.InfoWindow();
        this.resizeGoogleMaps();
        this.positionByAddress({value: this.getLocationFromAddress.bind(this) });
    }

    public openMarkerInfo(map: any, marker: any) {
        new this.mapsApi.Geocoder().geocode(
            { location: marker.getPosition() },
            (results, status) => {
                if (status === this.mapsApi.GeocoderStatus.OK) {
                    this.infoWindow.setContent(
                        results[0].formatted_address
                    );
                    this.infoWindow.open(map, marker);
                }
            }
        );
    }

    public mapLoaded() {
        if (!this.loaded) {
            if (this.marker != null) {
                this.marker.setMap(null);
            }
            if (this.location && this.location.Latitude && this.location.Longitude) {
                this.marker = new this.mapsApi.Marker({
                    map: this.readonly ? this.view : this.edit,
                    position: this.mapOptions.center,
                    title: this.title,
                    draggable: !this.readonly
                });
            }
            this.initMarkerListener();
            if (this.readonly) {
                this.view.setCenter(this.mapOptions.center);
            } else {
                this.edit.setCenter(this.mapOptions.center);
            }
            this.loaded = true;
        }
    }

    public setMarker($event: any, $params: any) {
        if (this.readonly) {
            this.resizeGoogleMaps();
            return;
        }
        if (this.marker != null) {
            this.marker.setMap(null);
        }
        this.marker = new this.mapsApi.Marker({
            map: this.readonly ? this.view : this.edit,
            position: $params[0].latLng,
            title: this.title,
            draggable: true
        });
        this.initMarkerListener();
        this.edit.setCenter($params[0].latLng);
        this.location.Latitude = $params[0].latLng.lat();
        this.location.Longitude = $params[0].latLng.lng();
        this.onLocationChanged({value: this.location });
    }

    public mapDragStart() {
        this.edit.setOptions({ draggingCursor: 'move' });
    }

    public mapDragEnd() {
        this.edit.setOptions({ draggingCursor: 'default' });
    }

    public clearSearch() {
        this.search = '';
    }

    public async getLocationFromAddress(address?: string): Promise<any> {
        const geocoder = new this.mapsApi.Geocoder();
        return new Promise((resolve) => {
            geocoder.geocode(
              {
                  address: address ? address : this.search
              },
              async (results, status) => {
                  if (status === this.mapsApi.GeocoderStatus.OK) {
                      this.setMarker(null, [
                          { latLng: results[0].geometry.location }
                      ]);
                      this.edit.setZoom(this.mapOptions.zoom);
                      resolve();
                  } else {
                      await this.$uibModal.open({
                          component: 'cantDeterminePositionComponent',
                          windowClass: 'base-modal',
                          appendTo: this.$document.find('.containerGmap '),
                          resolve: {
                              contentTranslateKey: () => this.contentTranslateKey ? this.contentTranslateKey : 'position_doesnt_coincide_of_location'
                          }
                      }).result;
                      resolve();
                  }
              }
            );
        });
    }

    private resizeGoogleMaps() {
        this.$timeout(() => {
            if (this.view || this.edit) {
                this.mapsApi.event.trigger(this.readonly ? this.view : this.edit, 'resize');
            }
        }, 300)
            .finally(() => this.isMapReady = true);
    }

    private initMarkerListener() {
        if (!this.readonly && this.marker && !this.markerListenerInitialized) {
            this.marker.addListener('drag', (event) => {
                this.location.Latitude = event.latLng.lat();
                this.location.Longitude = event.latLng.lng();
                this.onUpdateLocation();
            });
            this.markerListenerInitialized = true;
        }
    }
}

angular.module('app.common').component('googleMap', {
    template: require('./google-map.component.html'),
    controller: GoogleMapComponent,
    controllerAs: 'ctrl',
    bindings: {
        location: '=',
        readonly: '<',
        title: '<',
        mapClass: '<',
        contentTranslateKey: '<',
        search: '=',
        onUpdateLocation: '&',
        positionByAddress: '&',
        onLocationChanged: '&',
        searchFieldVisible: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/components/google-map/google-map.component.ts